import FontAwesome from "../../utilities/FontAwesome";
import { IconButton, VisuallyHidden } from "@radix-ui/themes";
import WatsonApi from "../../../backends/WatsonApi";
import { IPendingMessageAttachment } from "./Conversation";
import { useState } from "react";
import NotificationManager from "../../notifications/NotificationManager";

export function FileUploader(props: {
  addAttachment: (attachment: IPendingMessageAttachment) => void;
}) {
  const [loading, setLoading] = useState(false);
  async function handleChange(e) {
    if (e.target.files.length > 0) {
      setLoading(true);
      try {
        const client = await WatsonApi();
        const response =
          await client.apis.message_attachment.message_attachment_upload({
            file: e.target.files[0],
          });
        props.addAttachment(JSON.parse(response.data));
      } catch {
        NotificationManager.error("File upload failed. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  }

  const acceptedFileTypes = [
    "image/*",
    "audio/*",
    "video/*",
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    ".txt",
    ".csv",
  ].join(",");

  return (
    <IconButton disabled={loading} loading={loading} variant={"ghost"}>
      <label style={{ cursor: "pointer", margin: 0 }}>
        <FontAwesome name={"fa-paperclip"} prefix={"fas"} />
        <VisuallyHidden>
          <input
            accept={acceptedFileTypes}
            onChange={handleChange}
            type="file"
          />
        </VisuallyHidden>
      </label>
    </IconButton>
  );
}
